import { InputComponentWidth } from '../types';

// get the width class of a textField if a predefined width is used
export const getWidth = (width: InputComponentWidth | number) => {
  if (typeof width !== 'number') {
    switch (width) {
      case 'xxlarge':
        return '684px';
      case 'xlarge':
        return '556px';
      case 'large':
        return '448px';
      case 'medium':
        return '330px';
      case 'small':
        return '212px';
      case 'dialog':
        return '400px';
      case 'auto':
        return '100%';
    }
  } else if (typeof width === 'number') {
    return `${width}px`;
  }

  return '';
};
